import { useEffect, useState } from "react";
import { NAV_LINKS } from "@/data/content";
import { List, X, ShieldCheck } from "@phosphor-icons/react";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,box-shadow] duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-xl border-b border-slate-200/70 shadow-sm" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 h-20 flex items-center justify-between">
        <button data-testid="brand-logo" onClick={() => go("#top")} className="flex items-center gap-2.5 group">
          <ShieldCheck weight="fill" className="h-7 w-7 text-[#B91C1C]" />
          <span className="font-serif-display text-xl font-bold tracking-tight text-slate-900">
            Crestline<span className="text-slate-400 font-normal"> Risk</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-consult"
            onClick={() => go("#contact")}
            className="px-5 py-2.5 bg-slate-900 text-white text-sm font-semibold hover:bg-[#B91C1C] transition-colors duration-200"
          >
            Request a Consultation
          </button>
        </nav>

        <button data-testid="mobile-menu-toggle" className="lg:hidden text-slate-900" onClick={() => setOpen((v) => !v)}>
          {open ? <X className="h-7 w-7" /> : <List className="h-7 w-7" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-slate-200 px-6 py-4 space-y-1">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              className="block w-full text-left py-3 text-slate-700 hover:text-[#B91C1C] transition-colors duration-200 border-b border-slate-100"
            >
              {l.label}
            </button>
          ))}
          <button onClick={() => go("#contact")} className="mt-3 w-full py-3 bg-slate-900 text-white font-semibold">
            Request a Consultation
          </button>
        </div>
      )}
    </header>
  );
};
